export function getEnvDomain() {
  const env = window.location.host.replace('login.', '');

  if (env.includes('localhost')) {
    return 'dev.jupiterone.io';
  }

  return env;
}

export function getAppsDomain() {
  return `apps.${getEnvDomain()}`;
}

export function getAppsOrigin() {
  const { protocol } = window.location;
  return `${protocol}//${getAppsDomain()}`;
}
